"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/ClinicBranding/BrandingPreview.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _brandPalette = require('shared/services/brandPalette');

var _ClinicContactCard = require('./ClinicContactCard'); var _ClinicContactCard2 = _interopRequireDefault(_ClinicContactCard);

/* The branding page's preview (P-3): what a patient sees on the secure
 * link, from the page's unsaved values. Conversation shows the header and
 * a few messages in the clinic's colours; Contact card shows the card the ?
 * opens (or a line saying ? opens BloomText help when it is off). */








const PreviewHeader = ({ clinic }) => (
  _react2.default.createElement('div', { className: "branding-preview--header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}
    ,  clinic.LogoURL
      ? _react2.default.createElement('span', { className: "branding-preview--logo", __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}}, _react2.default.createElement('img', { src: clinic.LogoURL, alt: _nullishCoalesce(clinic.Name, () => ( '')), __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}} ))
      : (
          _react2.default.createElement('span', { className: "branding-preview--from", __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}}, "From: "
             , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 26}},  clinic.Name )
          )
        )
    , _react2.default.createElement('span', { className: "branding-preview--help", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}, "?")
  )
)

const BrandingPreview = ({ clinic, cardEnabled }) => {
  const [view, setView] = _react.useState('conversation')
  const showConversation = _react.useCallback.call(void 0, () => setView('conversation'), [])
  const showCard = _react.useCallback.call(void 0, () => setView('card'), [])
  const style = _react.useMemo.call(void 0, () => _brandPalette.brandPaletteStyle.call(void 0, _brandPalette.brandPalette.call(void 0, clinic.Color)), [clinic.Color])
  const panelId = _react.useId.call(void 0, )

  return (
    _react2.default.createElement('section', { className: "branding-preview", 'aria-label': "Preview", style: style, __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
      , _react2.default.createElement('div', { className: "branding-preview--tabs", role: "tablist", 'aria-label': "Preview of" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
        , _react2.default.createElement('button', {
          type: "button",
          role: "tab",
          'aria-selected': view === 'conversation',
          'aria-controls': panelId,
          className: _classBuilder2.default.call(void 0, 'branding-preview--tab', view === 'conversation' && 'branding-preview--tab-active'),
          onClick: showConversation, __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}
, "Conversation"

        )
        , _react2.default.createElement('button', {
          type: "button",
          role: "tab",
          'aria-selected': view === 'card',
          'aria-controls': panelId,
          className: _classBuilder2.default.call(void 0, 'branding-preview--tab', view === 'card' && 'branding-preview--tab-active'),
          onClick: showCard, __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}
, "Contact card"

        )
      )
      , _react2.default.createElement('div', { id: panelId, role: "tabpanel", className: "branding-preview--phone", __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
        , _react2.default.createElement(PreviewHeader, { clinic: clinic, __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}} )
        ,  view === 'conversation' && (
          _react2.default.createElement('div', { className: "branding-preview--chat", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}
            , _react2.default.createElement('div', { className: "branding-preview--bubble", __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}, "Hi Priya, your refill is ready for pickup."       )
            , _react2.default.createElement('div', { className: "branding-preview--bubble branding-preview--bubble-mine" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}
              , _react2.default.createElement('span', { className: "branding-preview--quote", __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}, "Your refill is ready for pickup."     ), "Thank you! Can my husband pick it up?"

            )
            , _react2.default.createElement('div', { className: "branding-preview--bubble", __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}, "Yes, he just needs his photo ID. "
                     , _react2.default.createElement('span', { className: "branding-preview--link", __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}, "See our hours"  )
            )
          )
        )
        ,  view === 'card' && (
          _react2.default.createElement('div', { className: "branding-preview--chat branding-preview--chat-dimmed" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}
            ,  cardEnabled
              ? (
                  _react2.default.createElement('div', { className: "branding-preview--sheet", __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}}
                    , _react2.default.createElement('div', { className: "branding-preview--grab", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}} )
                    , _react2.default.createElement(_ClinicContactCard2.default, { clinic: clinic, __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}} )
                  )
                )
              : _react2.default.createElement('p', { className: "branding-preview--card-off", __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}}, "With “Show to patients” off, ? opens BloomText help."        ) 
          )
        )
      )
      , _react2.default.createElement('p', { className: "branding-preview--caption", __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}
        ,  view === 'card' ? 'Preview of what a patient sees after tapping ?.' : 'Preview of the secure link.' 
      )
    )
  )
}

exports. default = BrandingPreview
